import { combineReducers } from 'redux'

import { isAvailableFeatureSelector } from 'features/billing'

import { reducer as list } from './list/slice'
import { reducer as addMembers } from './management/add_members/slice'
import { reducer as assignAdmins } from './management/assign_admins/slice'
import { reducer as management } from './management/slice'

export const reducer = combineReducers({
  list,
  management,
  add_members: addMembers,
  assign_admins: assignAdmins
})

export const isUserGroupsEnabledSelector = (state) => isAvailableFeatureSelector(state, { featureKey: 'user_groups' })
